import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const Root = styled(({ children, inIframe, ...props }) => <div {...props}>{children}</div>)`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: auto;
  padding: 0 10px;
  width: 100%;

  ${props => props.theme.breakpoints.only('xs')} {
    max-width: 540px;
  }

  ${props => props.theme.breakpoints.only('sm')} {
    max-width: 720px;
  }

  ${props => props.theme.breakpoints.only('md')} {
    max-width: ${props => (props.inIframe ? '1140px' : '960px')};
  }

  ${props => props.theme.breakpoints.only('lg')} {
    max-width: 1140px;
  }

  ${props => props.theme.breakpoints.only('xl')} {
    max-width: 1140px;
  }
`

export const Header = styled('section')`
  margin: 0;
  width: 100%;
`

export const TopContent = styled('section')`
  width: 100%;
`

export const Body = styled(BaseGrid)`
  &.MuiGrid-root {
    display: flex;
    height: auto;
    padding: 0;
    width: 100%;
  }
`

export const Section = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: 0 0 20px;
  }
`

export const Footer = styled('section')`
  width: 100%;
`
